import { parseISO, differenceInDays } from "date-fns";

export function getDiasTranscurridos(day1: string, day2: string): number {
  const date1 = parseISO(day1);
  const date2 = parseISO(day2);
  return Math.abs(differenceInDays(date1, date2));
}
